import axios from "axios";
// /* 设置默认地址 */
// axios.defaults.baseURL = 'http://ssck.hrclass.com.cn:8083'
// axios.defaults.baseURL = 'http://192.168.101.164:8085'

axios.defaults.baseURL = 'https://aid.hrclass.com.cn'

let pendingRequestCount = 0

function syncPrerenderPendingCount() {
    if (typeof window === 'undefined') {
        return
    }

    window.__PRERENDER_PENDING_REQUESTS__ = Math.max(pendingRequestCount, 0)
}

function increasePendingCount() {
    pendingRequestCount += 1
    syncPrerenderPendingCount()
}

function decreasePendingCount() {
    pendingRequestCount = Math.max(pendingRequestCount - 1, 0)
    syncPrerenderPendingCount()
}

syncPrerenderPendingCount()

axios.interceptors.request.use(config => {
    increasePendingCount()
    return config
}, error => {
    decreasePendingCount()
    return Promise.reject(error)
})

axios.interceptors.response.use(response => {
    decreasePendingCount()
    return response
}, error => {
    decreasePendingCount()
    return Promise.reject(error)
})

//判断设备类型
//返回true为pc，false为移动端
export function determineDeviceType() {
    //判断是否pc
    const mobileKeywords = ['android', 'iphone', 'ipad', 'ipod', 'windows phone', 'mobile'];
    // 1. 检查 UA 是否包含移动端关键词
    const isPc = !mobileKeywords.some(keyword => navigator.userAgent.toLowerCase().includes(keyword));
    return isPc;
}
export default axios;
